<template>
  <v-container :fluid="true" class="home__container">
    <LandingPageBanner
      :listBenefits="LANDLORD_LIST_BENEFITS"
      :title="title"
      :defaqtoImageUrl="defaqtoImageUrl"
      :bgImageMobileUrl="bgImageMobileUrl"
      :bgImageDesktopUrl="bgImageDesktopUrl"
      @openCreateLLQuoteDialog="openCreateLLQuoteDialog"
      @openRetrieveQuoteDialog="retrieveQuote"
    ></LandingPageBanner>

    <v-row class="definition-wrapper">
      <v-col>
        <v-row class="app-container--width-max mx-auto">
          <v-col cols="7" lg="6" class="left-panel-wrapper">
            <h2 class="mb-3">What is Landlord’s Insurance?</h2>
            <p>
              We believe Landlord's Insurance should be designed around the
              specialist needs of landlords. We're passionate about offering
              market-leading cover and a range of optional extras for those with
              rental properties to tailor their insurance to meet their needs.
            </p>
            <p>
              You can choose to insure just the buildings or add cover for any
              belongings inside the property that you'd like to protect. We also
              offer a range of optional extras allowing you to tailor your
              insurance to meet your needs.
            </p>
          </v-col>
          <v-col cols="5" lg="6">
            <img
              src="@/assets/images/landlord-insurance.png"
              alt="landlord-insurance"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <LandingPageTypeOfInsurance
      :typeOfInsuranceIntroducer="LANDLORD_TYPE_OF_INSURANCE"
      :typeInsurancesList="LANDLORD_TYPE_INSURANCES"
      @openCreateLLQuoteDialog="openCreateLLQuoteDialog"
    ></LandingPageTypeOfInsurance>

    <LandingPageInsurers :insurers="LANDLORD_INSURERS"> </LandingPageInsurers>

    <LandingPageWhatInsuranceCover
      :title="whatInsuranceCoverTitle"
      :insuranceCoverDes="LANDLORD_INSURANCE_COVER_DESCRIPTION"
    ></LandingPageWhatInsuranceCover>

    <LandingPageWhatAdditionalCover
      :addOns="LANDLORD_ADD_ONS"
      :additionalCoverDes="LANDLORD_ADDITIONAL_COVER_DESCRIPTION"
      @openCreateLLQuoteDialog="openCreateLLQuoteDialog"
    ></LandingPageWhatAdditionalCover>

    <v-row class="includes-wrapper">
      <v-col>
        <v-row class="app-container--width-max mx-auto dense">
          <v-col cols="12" lg="5" class="left-panel-wrapper">
            <h3 class="text-left">Protecting your</h3>
            <h1 class="font-lobster mb-5 text-left font-weight-regular">
              property
            </h1>
            <p class="pt-7">
              Paymentshield Landlord's Insurance gives you a comprehensive range
              of features and benefits.
            </p>
            <p class="pt-1">
              You can choose to insure just the buildings or add cover for any
              belongings inside the property that you'd like to protect. We also
              offer a range of optional extras allowing you to tailor your
              insurance to meet your needs.
            </p>
          </v-col>
          <v-col cols="12" lg="7" class="right-panel-wrapper">
            <h3 class="font-24">Our Buildings Insurance includes:</h3>
            <ul>
              <li>
                <v-icon color="teal" class="mr-2">mdi-shield</v-icon>Up to £1
                million of cover for damage to any outbuildings belonging to you
                within 100 metres of your property
              </li>
              <li>
                <v-icon color="teal" class="mr-2">mdi-shield</v-icon>Up to £2
                million property owners liability cover
              </li>
              <li>
                <v-icon color="teal" class="mr-2">mdi-shield</v-icon>If your
                locks are accidentally damaged or your keys are lost or stolen
              </li>
            </ul>
            <h3 class="mt-4 font-24">Our Contents Insurance includes:</h3>
            <ul>
              <li>
                <v-icon color="teal" class="mr-2">mdi-shield</v-icon>A selection
                of cover limits to choose from
              </li>
              <li>
                <v-icon color="teal" class="mr-2">mdi-shield</v-icon>Cover for
                malicious damage caused by a tenant as standard
              </li>
              <li>
                <v-icon color="teal" class="mr-2">mdi-shield</v-icon>Up to £500
                of cover for contents in the garden or open grounds of the
                insured property
              </li>
            </ul>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <LandingPagePolicyDocument
      :policyDocumentList="staticDocumentData"
    ></LandingPagePolicyDocument>

    <LandingPageWhyChoose
      @openCreateLLQuoteDialog="openCreateLLQuoteDialog"
    ></LandingPageWhyChoose>
    <RedirectDialog v-if="showRedirectDialog" />
    <BaseDialog
      ref="retrieveQuote"
      windowClass="pa-0 pb-xl-0 retrieve-quote"
      headerClass="retrieve-landlord-quote-header"
      :maxWidth="540"
      headerDivider
      persistent
      noClickAnimation
      closeIcon="ic_close.svg"
      @dialogCloseButton="closeRetrieveQuoteForm"
    >
      <template #closeIcon>
        <img class="logo" src="@/assets/icons/ic_close.svg" alt="close_icon" />
      </template>
      <template v-slot:content>
        <DialogContentRetrieveLandlordQuote
          v-if="showRetrieveQuoteForm"
          :quoteReference="quoteReference"
          :pageProductId="pageProductId"
          @showEligibility="onShowEligibility"
        />
      </template>
    </BaseDialog>
    <CreateLLQuoteDialog
      v-if="dialogCreateLLQuoteVisible"
      ref="dialogCreateLLQuote"
      :confirmText="'Return to homepage'"
      :isSaveAndExit="false"
      :isSelfserve="true"
      :insuredParty="insuredParty"
      :businessName="companyName"
      @openEligibilityDialog="openEligibilityDialog"
      @companyName="inputCompanyName"
      @quoteTypeSelected="inputQuoteTypeSelected"
      @cancel="() => (dialogCreateLLQuoteVisible = false)"
    ></CreateLLQuoteDialog>
    <EligibilityDialogWrapper
      ref="EligibilityDialogWrapper"
      :continuationUrl="continuationUrl"
      @onConfirmEligibility="onConfirmEligibility"
    />
    <v-overlay :value="processingRequest">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
import { getQuoteAccessIdFromUrl } from "@/common/quotes";
import {
  applyD2CThirdPartyId,
  getLatestStaticDocuments,
  scrollTop,
} from "@/common/utils";
import BaseDialog from "@/components/BaseComponents/BaseDialog.vue";
import LandingPageBanner from "@/components/D2CSharedComponents/LandingPageBannerComponent.vue";
import LandingPageInsurers from "@/components/D2CSharedComponents/LandingPageInsurersComponent.vue";
import LandingPagePolicyDocument from "@/components/D2CSharedComponents/LandingPagePolicyDocumentComponent.vue";
import LandingPageTypeOfInsurance from "@/components/D2CSharedComponents/LandingPageTypeOfInsuranceComponent.vue";
import LandingPageWhatAdditionalCover from "@/components/D2CSharedComponents/LandingPageWhatAdditionalCoverComponent.vue";
import LandingPageWhatInsuranceCover from "@/components/D2CSharedComponents/LandingPageWhatInsuranceCoverComponent.vue";
import LandingPageWhyChoose from "@/components/D2CSharedComponents/LandingPageWhyChooseComponent.vue";
import DialogContentRetrieveLandlordQuote from "@/components/QuoteResult/DialogContentRetrieveLandlordQuote.vue";
import {
  INSURED_PARTY,
  LANDLORD_TYPE,
  PRODUCT,
} from "@/constants/common.constants";
import {
  LANDLORD_ADD_ONS,
  LANDLORD_ADDITIONAL_COVER_DESCRIPTION,
  LANDLORD_INSURANCE_COVER_DESCRIPTION,
  LANDLORD_INSURERS,
  LANDLORD_LIST_BENEFITS,
  LANDLORD_POLICY_DOCUMENT,
  LANDLORD_TYPE_INSURANCES,
  LANDLORD_TYPE_OF_INSURANCE,
} from "@/constants/d2c-landing-page.constants.js";
import {
  LANDLORD_COMPANY_ELIGIBILITY,
  LANDLORD_ELIGIBILITY,
  LANDLORD_ELIGIBILITY_INFO_MSG,
} from "@/constants/eligibility.constants";
import quoteService from "@/services/quote.service";
import sessionService from "@/services/session.service";
import { QUESTIONS_MODULE } from "@/store/types/module-types";
import CreateLLQuoteDialog from "@/views/Dialog/CreateLLQuoteDialog.vue";
import EligibilityDialogWrapper from "@/views/Dialog/EligibilityDialogWrapper.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "D2CLandlordWelcomePage",
  components: {
    LandingPageBanner,
    LandingPageTypeOfInsurance,
    LandingPageInsurers,
    LandingPageWhatInsuranceCover,
    LandingPageWhatAdditionalCover,
    LandingPagePolicyDocument,
    LandingPageWhyChoose,
    EligibilityDialogWrapper,
    CreateLLQuoteDialog,
    BaseDialog,
    DialogContentRetrieveLandlordQuote,
    RedirectDialog: () => import("@/views/Dialog/RedirectDialog.vue"),
  },
  data() {
    return {
      LANDLORD_LIST_BENEFITS,
      defaqtoImageUrl: require("@/assets/images/defaqto/landlord-home-insurance.svg"),
      bgImageUrl: require("@/assets/images/hero_landlord_1920.png"),
      title: "LANDLORD'S INSURANCE",
      whatInsuranceCoverTitle: "What does Landlord’s Insurance cover?",
      LANDLORD_TYPE_OF_INSURANCE,
      LANDLORD_TYPE_INSURANCES,
      LANDLORD_INSURERS,
      LANDLORD_ADD_ONS,
      LANDLORD_ELIGIBILITY_INFO_MSG,
      LANDLORD_ELIGIBILITY,
      LANDLORD_COMPANY_ELIGIBILITY,
      PRODUCT: PRODUCT,
      LANDLORD_TYPE: LANDLORD_TYPE,
      showRetrieveQuoteForm: false,
      showRedirectDialog: false,
      processingRequest: false,
      isDownloadError: false,
      quoteReference: null,
      bgImageMobileUrl: require("@/assets/images/hero_landlord_mobile.png"),
      bgImageDesktopUrl: require("@/assets/images/hero_landlord.png"),
      pageProductId: ["1009"],
      continuationUrl: "",
      eligibilityContinuationUrl: null,
      retrieveQuoteDialogHeader: "New quote",
      insuredParty: null,
      companyName: null,
      quoteAccessId: null,
      dialogCreateLLQuoteVisible: false,
      LANDLORD_INSURANCE_COVER_DESCRIPTION,
      LANDLORD_ADDITIONAL_COVER_DESCRIPTION,
      LANDLORD_POLICY_DOCUMENT,
      staticDocumentData: [],
    };
  },
  computed: {
    ...mapGetters(QUESTIONS_MODULE, [
      "httpConfig",
      "contactInfo",
      "preparedAnswers",
    ]),
  },
  mounted() {
    scrollTop();
    applyD2CThirdPartyId();
    const quoteReferenceQuery = this.$route.query.quoteReference;
    if (quoteReferenceQuery) {
      this.quoteReference = quoteReferenceQuery;
      this.retrieveQuote();
    }
    this.getAppConfigurationContactInfo();

    //call API get lastest static document
    this.getStaticDocuments();
  },
  methods: {
    ...mapActions(QUESTIONS_MODULE, [
      "getAppConfigurationContactInfo",
      "setD2CLandlordMissingAnswers",
      "setInsuredParty",
      "setCompanyName",
      "confirmEligibility",
    ]),
    async getStaticDocuments() {
      try {
        this.staticDocumentData = await getLatestStaticDocuments(
          PRODUCT.LandLord,
          LANDLORD_POLICY_DOCUMENT
        );
      } catch (error) {
        this.isDownloadError = true;
      }
    },
    async onConfirmEligibility(productId, landLordType) {
      this.processingRequest = true;
      if (this.quoteAccessId) {
        await this.saveConfirmEligibility();
      } else {
        await this.createQuote(false, productId, landLordType);
      }
      this.processingRequest = false;
    },
    openEligibilityDialog(showCompanyInput) {
      this.dialogCreateLLQuoteVisible = false;
      showCompanyInput == false
        ? this.$refs.EligibilityDialogWrapper?.$refs.dialogEligibilityLandLord.open(
            "Eligibility check"
          )
        : this.$refs.EligibilityDialogWrapper?.$refs.dialogEligibilityLandLordCompany.open(
            "Eligibility check"
          );
    },
    async openCreateLLQuoteDialog() {
      this.processingRequest = true;
      const startResult = await this.startSession(false);
      this.processingRequest = false;
      if (startResult === true) {
        this.insuredParty = null;
        this.companyName = null;
        this.dialogCreateLLQuoteVisible = true;
      }
    },
    inputCompanyName(val) {
      this.companyName = val;
      this.setCompanyName(val);
    },
    inputQuoteTypeSelected(value) {
      this.insuredParty =
        value?.toLowerCase() === LANDLORD_TYPE.Company.toLowerCase()
          ? INSURED_PARTY.Business
          : INSURED_PARTY.Individual;
      this.setInsuredParty(this.insuredParty);
    },
    /**
     * Start the session with the BFF api
     */
    async startSession(stayInHomePage) {
      try {
        if (this.isQuoteRefereceValid() || this.isLeadIdValid()) {
          await sessionService.startD2CSession(
            this.isLeadIdValid() ? this.$route.query.leadId : null,
            this.$route.query.quoteReference,
            PRODUCT.LandLord
          );
          return true;
        } else {
          this.openRedirectDialog();
          return false;
        }
      } catch (e) {
        if (
          (!stayInHomePage && e?.response?.status == 404) ||
          e?.response?.status == 403
        ) {
          this.openRedirectDialog();
        }
        return false;
      }
    },
    /**
     * Prepare default answers for different type of Insured party
     * @param {String} insuredPartyType
     */
    prepareLandlordAnswer(insuredPartyType) {
      const updatedAnswers = [];
      if (insuredPartyType == LANDLORD_TYPE.Company) {
        updatedAnswers.push(
          {
            InterfaceKey: "InsuredParty",
            Value: INSURED_PARTY.Business,
          },
          {
            InterfaceKey: "CompanyName",
            Value: this.companyName,
          }
        );
      } else {
        updatedAnswers.push({
          InterfaceKey: "InsuredParty",
          Value: INSURED_PARTY.Individual,
        });
      }
      return updatedAnswers;
    },
    async createQuote(stayInHomePage, productId, landLordType) {
      try {
        const answers = this.prepareLandlordAnswer(landLordType);
        const response = await quoteService.createOnlineQuote(
          answers,
          productId
        );

        window.location.href = response.QuoteRequestContinuationUri;
      } catch (e) {
        if (
          (!stayInHomePage && e?.response?.status == 404) ||
          e?.response?.status == 403
        ) {
          this.openRedirectDialog();
        }
      }
    },
    async saveConfirmEligibility() {
      try {
        const url = await this.confirmEligibility(this.quoteAccessId);
        window.location.href = url;
      } catch (e) {
        console.error(e);
      } finally {
        this.quoteAccessId = null;
      }
    },
    retrieveQuote() {
      this.showRetrieveQuoteForm = true;
      this.$refs.retrieveQuote.open("Retrieve a quote");
    },
    closeRetrieveQuoteForm() {
      // smooth out animation when closing dialog
      setTimeout(() => (this.showRetrieveQuoteForm = false), 100);
    },
    openRedirectDialog() {
      this.showRedirectDialog = true;
    },
    isQuoteRefereceValid() {
      return !!this.$route.query.quoteReference;
    },
    isLeadIdValid() {
      return !(
        this.$route.query.leadId == null ||
        this.$route.query.leadId === "" ||
        isNaN(this.$route.query.leadId) ||
        parseInt(this.$route.query.leadId) <= 0
      );
    },
    onShowEligibility(continuationUrl, insuredParty, companyName) {
      this.quoteAccessId = getQuoteAccessIdFromUrl(continuationUrl);
      this.insuredParty = insuredParty;
      this.companyName = companyName;

      // close retrieve form
      this.$refs.retrieveQuote.cancel();
      this.closeRetrieveQuoteForm();

      this.dialogCreateLLQuoteVisible = true;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/scss/d2c/welcome.scss";
:deep(.logo-wrapper) {
  padding-left: 200px;
  padding-right: 200px;
}

:deep(.insurers-wrapper) {
  .logo__item {
    .logo {
      &-axa {
        max-height: 54px;
      }
      &-lv {
        max-height: 49px;
      }
      &-rsa {
        max-height: 49px;
      }
      &-ukgeneral {
        max-height: 36px;
      }
    }
  }
}

@media screen and (max-width: ($grid-breakpoints-lg - 1)) {
  :deep(.logo-wrapper) {
    padding-left: 0;
    padding-right: 0;
    .logo__item--wrapper {
      width: 50%;
      margin-bottom: 20px;
      text-align: center;
      .logo__item {
        width: 100%;
        img {
          max-width: 50%;
        }
      }
    }
  }
}

@media screen and (min-width: $grid-breakpoints-shd) {
  .landing-wrapper {
    background-image: url(~@/assets/images/hero_landlord_1920.png) !important;
  }
}
</style>
